import { render, staticRenderFns } from "./BookmarkButton.vue?vue&type=template&id=0498813b&scoped=true"
import script from "./BookmarkButton.vue?vue&type=script&lang=js"
export * from "./BookmarkButton.vue?vue&type=script&lang=js"
import style0 from "./BookmarkButton.vue?vue&type=style&index=0&id=0498813b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0498813b",
  null
  
)

export default component.exports